/**
 * RESERVE PRODUCT PAGE
 * Handles: quantity-tier (variant) selection, quantity stepper,
 * accordion toggles, gallery thumbnail switching, and the
 * sticky buy bar's show/hide + price sync.
 *
 * No cart AJAX is implemented here beyond the native form post —
 * the form already posts to /cart/add, and {{ form | payment_button }}
 * in the Liquid section renders Shopify's native Shop Pay / Apple Pay
 * dynamic checkout button automatically. This script only handles
 * the UI state (which variant + quantity is selected) so both the
 * "Add to Cart" submit and the dynamic checkout button use the
 * right variant ID.
 */
document.addEventListener('DOMContentLoaded', function () {
  const root = document.querySelector('.reserve-product');
  if (!root) return;

  const variantInput = root.querySelector('#RpSelectedVariantId');
  const qtyInput = root.querySelector('#RpQuantityInput');
  const stepperVal = root.querySelector('#RpStepperVal');
  const stickyPrice = root.querySelector('#RpStickyPrice');
  const stickyBar = root.querySelector('#RpStickyBar');
  const buyForm = root.querySelector('#RpProductForm');

  let quantity = 1;

  // ---- Quantity tier (variant) selection ----
  root.querySelectorAll('.rp-qty-opt').forEach(function (opt) {
    opt.addEventListener('click', function () {
      root.querySelectorAll('.rp-qty-opt').forEach(function (o) { o.classList.remove('is-selected'); });
      opt.classList.add('is-selected');
      const radio = opt.querySelector('.rp-qty-opt__radio-input');
      if (radio) radio.checked = true;
      const variantId = opt.getAttribute('data-variant-id');
      if (variantInput) variantInput.value = variantId;
      updateStickyPrice();
    });
  });

  // ---- Quantity stepper ----
  root.querySelectorAll('[data-stepper]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const dir = btn.getAttribute('data-stepper') === 'plus' ? 1 : -1;
      quantity = Math.max(1, quantity + dir);
      if (stepperVal) stepperVal.textContent = quantity;
      if (qtyInput) qtyInput.value = quantity;
      updateStickyPrice();
    });
  });

  function selectedUnitPrice() {
    const selected = root.querySelector('.rp-qty-opt.is-selected');
    if (!selected) return 0;
    return parseFloat(selected.getAttribute('data-price')) || 0;
  }

  function updateStickyPrice() {
    if (!stickyPrice) return;
    const total = (selectedUnitPrice() * quantity).toFixed(2);
    stickyPrice.textContent = '$' + total;
  }

  // ---- Accordion ----
  root.querySelectorAll('[data-acc-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const item = btn.closest('.rp-acc-item');
      const wasOpen = item.classList.contains('is-open');
      root.querySelectorAll('.rp-acc-item').forEach(function (i) {
        i.classList.remove('is-open');
        i.querySelector('[data-acc-toggle]').setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ---- Gallery thumbnails ----
  root.querySelectorAll('.rp-gallery__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      root.querySelectorAll('.rp-gallery__thumb').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      // Swap main image via the theme's media API / product.js if available.
      // Left as an integration point — most 2.0 themes expose a
      // `Shopify.Theme.mediaSwitch(mediaId)` helper or similar.
    });
  });

  // ---- Sticky bar visibility ----
  if (stickyBar && buyForm) {
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { rootMargin: '-100px 0px 0px 0px' });
    observer.observe(buyForm);

    stickyBar.querySelector('[data-sticky-buy]').addEventListener('click', function () {
      buyForm.querySelector('.shopify-payment-button__button')?.click();
    });
  }

  updateStickyPrice();
});
